import GrowingGrasIcon from './growing-gras-icon';
export default GrowingGrasIcon;
